import Icon from '../components/Icon.vue'

Icon.register({"box":{"width":512,"height":512,"paths":[{"d":"M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272V192H510.7C510.3 189.5 510.3 187 509.5 184.6zM240 0H98.6C77.9 0 59.6 13.2 53.1 32.8L2.5 184.6C1.7 187 1.7 189.5 1.3 192H240V0zM0 224V464C0 490.5 21.5 512 48 512H464C490.5 512 512 490.5 512 464V224H0z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/box.js
// module id = null
// module chunks = 